import * as z from "zod/v4";

export const getAccountingConnectionSettings = {
  name: "getAccountingConnectionSettings" as const,
  input: z.null(),
  output: z.object({
    syncPurchaseOrders: z.boolean(),
    syncItems: z.boolean(),
    costMethod: z.enum(["fifo", "weighted_average"]),
  }),
};
